import { render, staticRenderFns } from "./WorkOrderManagementPage.vue?vue&type=template&id=2ed5156d&scoped=true"
import script from "./WorkOrderManagementPage.vue?vue&type=script&lang=js"
export * from "./WorkOrderManagementPage.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderManagementPage.vue?vue&type=style&index=0&id=2ed5156d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5156d",
  null
  
)

export default component.exports